import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';

const state = {
    cajasMovimientos: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    /* Filtro */
    fechaDesde: moment(new Date()).add(-30, 'days').format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.cajasMovimientos = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.fechaDesde = moment(new Date()).add(-30, 'days').format('YYYY-MM-DD');
        state.fechaHasta = moment(new Date()).format('YYYY-MM-DD');
    },

    'INICIALIZAR_CAJAS_MOVIMIENTOS' (state) {
        state.cajasMovimientos = [];
    },
    'SET_CAJAS_MOVIMIENTOS' (state, cajasMovimientos) {
        state.cajasMovimientos = cajasMovimientos;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getCajasMovimientos ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_CAJAS_MOVIMIENTOS');

            let queryString = '?fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD');
            
            if (state.paginaActual != 0) {
              queryString += '&pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual
            }
            /*
            if (state.proveedor) {
                if (state.proveedor.id != 0) {
                    queryString += '&proveedorId=' + state.proveedor.id;
                }
            }
            */
            apiAxios.get('cajasmovimientos' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_CAJAS_MOVIMIENTOS', res.data);

                    resolve();
                })
                .catch(error =>  {
                    reject(error);
                })
        }, error => {
            reject(error);
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}